import * as React from 'react';
import { PonderaFooter } from '../../components';

export class PVAContentBody extends React.Component {
    public render() {
        return (
            <div className="content-body">
                <div className="content-container">
                    {this.props.children}
                </div>
                <PonderaFooter />
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/layout/PVAContentBody.tsx